<template>
  <div class="ecomm">
    <v-alert v-show="alert" color="secondary" icon="warning" value="true" outline>
      Attention, les paramètres ecommerces ne sont pas accessibles pour ce niveau de licence. Vous ne pourrez pas sauvegarder.
    </v-alert>
    <!-- Chargement -->
    <div v-if="loadingGet" class="text-xs-center">
      <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
    </div>
    <!-- Formulaire -->
    <div v-else>
      <!-- CMS -->
      <v-card class="mb-3">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm6 md4>
              <v-select 
                :items="cms" 
                v-model="form.cms"
                dense
                :label="$t('select') + ' CMS' | cap"
                :hint="$t('cmsSettingsHint')"
                persistent-hint
                return-object
              ></v-select>
            </v-flex>
            <v-flex xs12 md2>
              <v-btn
                flat
                :block="$vuetify.breakpoint.xsOnly"
                class="primary--text"
                @click="cmsChanged()"
              >{{ $t('applyCmsSettings') }}</v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
      <v-expansion-panel>
        <!-- Bouton ajout panier -->
        <v-expansion-panel-content>
          <div slot="header"><v-icon class="mr-2 primary--text">insert_drive_file</v-icon>Pages</div>
          <v-card class="grey lighten-3">
            <v-card-text>
              <v-expansion-panel class="mb-3">
                <v-expansion-panel-content>
                  <v-layout align-center row spacer slot="header" ellipsis>
                    <v-flex xs2>
                      {{ $t('basket') | cap }}
                    </v-flex>
                    <v-flex v-if="form.opt_1.text && form.input_1" xs10 hidden-sm-and-down>
                      {{ $t('contains') }} {{ form.opt_1.text }} : <code>{{ form.input_1 }}</code>
                    </v-flex>
                  </v-layout>
                  <v-card class="grey lighten-3">
                    <v-card-text>
                      <v-select :label="$t('contains') | cap" :items="opts" v-model="form.opt_1" return-object></v-select>
                      <v-text-field v-model="form.input_1" :label="$t('urlString') | cap"></v-text-field>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                  <v-layout align-center row spacer slot="header" ellipsis>
                    <v-flex xs2>
                      {{ $t('identification') | cap }}
                    </v-flex>
                    <v-flex v-if="form.opt_2.text && form.input_2" xs10 hidden-sm-and-down>
                      {{ $t('contains') }} {{ form.opt_2.text }} : <code>{{ form.input_2 }}</code>
                    </v-flex>
                  </v-layout>
                  <v-card class="grey lighten-3">
                    <v-card-text>
                      <v-select :label="$t('contains') | cap" :items="opts" v-model="form.opt_2" return-object></v-select>
                      <v-text-field v-model="form.input_2" :label="$t('urlString') | cap"></v-text-field>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                  <v-layout align-center row spacer slot="header" ellipsis>
                    <v-flex xs2>
                      {{ $t('delivery') | cap }}
                    </v-flex>
                    <v-flex v-if="form.opt_3.text && form.input_3" xs10 hidden-sm-and-down>
                      {{ $t('contains') }} {{ form.opt_3.text }} : <code>{{ form.input_3 }}</code>
                    </v-flex>
                  </v-layout>
                  <v-card class="grey lighten-3">
                    <v-card-text>
                      <v-select :label="$t('contains') | cap" :items="opts" v-model="form.opt_3" return-object></v-select>
                      <v-text-field v-model="form.input_3" :label="$t('urlString') | cap"></v-text-field>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                  <v-layout align-center row spacer slot="header" ellipsis>
                    <v-flex xs2>
                      {{ $t('summary') | cap }}
                    </v-flex>
                    <v-flex v-if="form.opt_4.text && form.input_4" xs10 hidden-sm-and-down>
                      {{ $t('contains') }} {{ form.opt_4.text }} : <code>{{ form.input_4 }}</code>
                    </v-flex>
                  </v-layout>
                  <v-card class="grey lighten-3">
                    <v-card-text>
                      <v-select :label="$t('contains') | cap" :items="opts" v-model="form.opt_4" return-object></v-select>
                      <v-text-field v-model="form.input_4" :label="$t('urlString') | cap"></v-text-field>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                  <v-layout align-center row spacer slot="header" ellipsis>
                    <v-flex xs2>
                      {{ $t('payment') | cap }}
                    </v-flex>
                    <v-flex v-if="form.opt_5.text && form.input_5" xs10 hidden-sm-and-down>
                      {{ $t('contains') }} {{ form.opt_5.text }} : <code>{{ form.input_5 }}</code>
                    </v-flex>
                  </v-layout>
                  <v-card class="grey lighten-3">
                    <v-card-text>
                      <v-select :label="$t('contains') | cap" :items="opts" v-model="form.opt_5" return-object></v-select>
                      <v-text-field v-model="form.input_5" :label="$t('urlString') | cap"></v-text-field>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                  <v-layout align-center row spacer slot="header" ellipsis>
                    <v-flex xs2>
                      {{ $t('validation') | cap }}
                    </v-flex>
                    <v-flex v-if="form.opt_6.text && form.input_6" xs10 hidden-sm-and-down>
                      {{ $t('contains') }} {{ form.opt_6.text }} : <code>{{ form.input_6 }}</code>
                    </v-flex>
                  </v-layout>
                  <v-card class="grey lighten-3">
                    <v-card-text>
                      <v-select :label="$t('contains') | cap" :items="opts" v-model="form.opt_6" return-object></v-select>
                      <v-text-field v-model="form.input_6" :label="$t('urlString') | cap"></v-text-field>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <v-expansion-panel-content>
          <!-- Bouton ajout panier -->
          <div slot="header"><v-icon class="mr-2 primary--text">add_shopping_cart</v-icon>{{ $t('addToTheBasket') }}</div>
          <v-card class="grey lighten-3">
            <v-card-text>
              <v-expansion-panel class="mb-3">
                <v-expansion-panel-content>
                  <v-layout align-center row spacer slot="header" ellipsis>
                    <v-flex xs5 md2>
                      {{ $t('button') | cap }}
                    </v-flex>
                    <v-flex v-if="form.input_r_1" xs7>
                      <span class="hidden-sm-and-down">{{ $t('identifiedBy') }} :</span> <code>{{ form.r_1 }}{{ form.input_r_1 }}</code>
                    </v-flex>
                  </v-layout>
                  <v-card class="grey lighten-3">
                    <v-card-text>
                      <v-radio-group v-model="form.r_1" row>
                        <v-radio label="class" class="primary--text" value="."></v-radio>
                        <v-radio label="id" class="primary--text" value="#"></v-radio>
                      </v-radio-group>
                      <v-text-field v-model="form.input_r_1" :label="$t('name') | cap"></v-text-field>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                  <v-layout align-center row spacer slot="header" ellipsis>
                    <v-flex xs5 md2>
                      {{ $t('priceOfProduct') | cap }}
                    </v-flex>
                    <v-flex v-if="form.input_r_2" xs7>
                      <span class="hidden-sm-and-down">{{ $t('identifiedBy') }} :</span> <code>{{ form.r_2 }}{{ form.input_r_2 }}</code>
                    </v-flex>
                  </v-layout>
                  <v-card class="grey lighten-3">
                    <v-card-text>
                      <v-radio-group v-model="form.r_2" row>
                        <v-radio label="class" class="primary--text" value="."></v-radio>
                        <v-radio label="id" class="primary--text" value="#"></v-radio>
                      </v-radio-group>
                      <v-text-field v-model="form.input_r_2" :label="$t('name') | cap"></v-text-field>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                  <v-layout align-center row spacer slot="header" ellipsis>
                    <v-flex xs5 md2>
                      {{ $t('productName') | cap }}
                    </v-flex>
                    <v-flex v-if="form.input_r_3" xs7>
                      <span class="hidden-sm-and-down">{{ $t('identifiedBy') }} :</span> <code>{{ form.r_3 }}{{ form.input_r_3 }}</code>
                    </v-flex>
                  </v-layout>
                  <v-card class="grey lighten-3">
                    <v-card-text>
                      <v-radio-group v-model="form.r_3" row>
                        <v-radio label="class" class="primary--text" value="."></v-radio>
                        <v-radio label="id" class="primary--text" value="#"></v-radio>
                      </v-radio-group>
                      <v-text-field v-model="form.input_r_3" :label="$t('name') | cap"></v-text-field>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <v-expansion-panel-content>
          <!-- État du panier -->
          <div slot="header"><v-icon class="mr-2 primary--text">shopping_cart</v-icon>{{ $t('basket') | cap }}</div>
          <v-card class="grey lighten-3">
            <v-card-text>
              <v-expansion-panel class="mb-3">
                <v-expansion-panel-content>
                  <v-layout align-center row spacer slot="header" ellipsis>
                    <v-flex xs5 md2>
                      {{ $t('amount') | cap }}
                    </v-flex>
                    <v-flex v-if="form.input_r_4" xs7>
                      <span class="hidden-sm-and-down">{{ $t('identifiedBy') }} :</span> <code>{{ form.r_4 }}{{ form.input_r_4 }}</code>
                    </v-flex>
                  </v-layout>
                  <v-card class="grey lighten-3">
                    <v-card-text>
                      <v-radio-group v-model="form.r_4" row>
                        <v-radio label="class" class="primary--text" value="."></v-radio>
                        <v-radio label="id" class="primary--text" value="#"></v-radio>
                      </v-radio-group>
                      <v-text-field v-model="form.input_r_4" :label="$t('name') | cap"></v-text-field>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                  <v-layout align-center row spacer slot="header" ellipsis>
                    <v-flex xs5 md2>
                      {{ $tc('items', 2, {count: ''}) | cap }}
                    </v-flex>
                    <v-flex v-if="form.input_r_5" xs7>
                      <span class="hidden-sm-and-down">{{ $t('identifiedBy') }} :</span> <code>{{ form.r_5 }}{{ form.input_r_5 }}</code>
                    </v-flex>
                  </v-layout>
                  <v-card class="grey lighten-3">
                    <v-card-text>
                      <v-radio-group v-model="form.r_5" row>
                        <v-radio label="class" class="primary--text" value="."></v-radio>
                        <v-radio label="id" class="primary--text" value="#"></v-radio>
                      </v-radio-group>
                      <v-text-field v-model="form.input_r_5" :label="$t('name') | cap"></v-text-field>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <!-- Validation du formulaire -->
      <div class="text-xs-right">
        <v-btn
          color="primary"
          flat
          dark
          :block="$vuetify.breakpoint.xsOnly"
          @click.native="reset()"
        >{{ $t('cancel') }}<v-icon class="primary--text" right>settings_backup_restore</v-icon>
        </v-btn>
        <v-btn
          color="primary"
          :block="$vuetify.breakpoint.xsOnly"
          :loading="loadingPost"
          @click.native="submit()"
          :disabled="alert"
        >{{ $t('save') }}<v-icon dark right>save</v-icon>
        </v-btn>
      </div>
    </div>
    <!-- dialog progress bar installation -->
    <wz-dialog-progress
      @fermeDialogProgress="fermeDialogProgress"
      :dialogProgress="dialogProgress"
      :etape=8
    >
    </wz-dialog-progress>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  data () {
    return {
      alert: false,
      // Données récupérées de la BDD
      dataFromAjax: {},
      //  Liste des CMS
      cms: [
        { text: _.upperFirst(this.$t('doNotKnow')), value: 'Autre' },
        { text: 'Prestashop1.5', value: 'Prestashop1.5' },
        { text: 'Prestashop1.6', value: 'Prestashop1.6' },
        { text: 'Woocommerce1.6', value: 'Woocommerce1.6' },
        { text: 'Woocommerce2.0', value: 'Woocommerce2.0' },
        { text: 'Magento', value: 'Magento' },
        { text: 'EShop', value: 'EShop' },
        { text: 'OpenCart', value: 'OpenCart' },
        { text: 'Virtuemart', value: 'Virtuemart' },
        { text: 'ZenCart', value: 'ZenCart' },
        { text: 'Powerboutique', value: 'Powerboutique' },
        { text: _.upperFirst(this.$t('other')), value: 'Autre' }
      ],
      form: {},
      opts: [
        { text: this.$t('nextStringUrl'), value: 'url' },
        { text: this.$t('uniqueIdSourceCode'), value: 'id' },
        { text: this.$t('meta'), value: 'kw' },
        { text: this.$t('stringTitle'), value: 'title' },
        { text: this.$t('tagApiSourceCode'), value: 'tag' }
      ],
      infosCMS: [
        {
          cmsName: 'Prestashop1.5',
          opt_1: 'url',
          input_1: 'order',
          opt_2: 'url',
          input_2: 'authentication',
          opt_3: 'url',
          input_3: 'order',
          opt_4: 'url',
          input_4: 'order',
          opt_5: 'url',
          input_5: 'order',
          opt_6: 'url',
          input_6: 'order',
          r_1: '#',
          input_r_1: 'add_to_cart',
          r_2: '.',
          input_r_2: 'product-price',
          r_3: '.',
          input_r_3: 'product-name',
          r_4: '.',
          input_r_4: '',
          r_5: '.',
          input_r_5: ''
        }, {
          cmsName: 'Prestashop1.6',
          opt_1: 'url',
          input_1: 'commande',
          opt_2: 'url',
          input_2: 'authentification',
          opt_3: 'url',
          input_3: 'adresse',
          opt_4: 'url',
          input_4: 'commande?multi-shipping',
          opt_5: 'url',
          input_5: 'systempay/redirect',
          opt_6: 'url',
          input_6: 'fin',
          r_1: '.',
          input_r_1: 'ajax_add_to_cart_button',
          r_2: '.',
          input_r_2: 'product-price',
          r_3: '.',
          input_r_3: 'product-name',
          r_4: '.',
          input_r_4: '',
          r_5: '.',
          input_r_5: ''
        }, {
          cmsName: 'Woocommerce1.6',
          opt_1: 'url',
          input_1: 'checkout',
          opt_2: 'url',
          input_2: 'account',
          opt_3: 'url',
          input_3: 'checkout',
          opt_4: 'url',
          input_4: 'checkout',
          opt_5: 'url',
          input_5: 'checkout',
          opt_6: 'url',
          input_6: 'checkout',
          r_1: '.',
          input_r_1: 'add_to_cart_button',
          r_2: '.',
          input_r_2: 'product-price',
          r_3: '.',
          input_r_3: 'product-name',
          r_4: '.',
          input_r_4: '',
          r_5: '.',
          input_r_5: ''
        }, {
          cmsName: 'Woocommerce2.0',
          opt_1: 'url',
          input_1: 'cart',
          opt_2: 'url',
          input_2: 'account',
          opt_3: 'url',
          input_3: 'checkout',
          opt_4: 'url',
          input_4: 'cart',
          opt_5: 'url',
          input_5: 'checkout',
          opt_6: 'url',
          input_6: 'checkout',
          r_1: '.',
          input_r_1: 'add_to_cart_button',
          r_2: '.',
          input_r_2: 'product-price',
          r_3: '.',
          input_r_3: 'product-name',
          r_4: '.',
          input_r_4: '',
          r_5: '.',
          input_r_5: ''
        }, {
          cmsName: 'Magento',
          opt_1: 'url',
          input_1: 'checkout/cart/',
          opt_2: 'url',
          input_2: 'checkout/onepage/',
          opt_3: 'url',
          input_3: 'checkout/onepage/',
          opt_4: 'url',
          input_4: 'checkout/cart/',
          opt_5: 'url',
          input_5: 'checkout/onepage/',
          opt_6: 'url',
          input_6: 'checkout/onepage/',
          r_1: '.',
          input_r_1: 'btn-cart',
          r_2: '.',
          input_r_2: 'product-price',
          r_3: '.',
          input_r_3: 'product-name',
          r_4: '.',
          input_r_4: '',
          r_5: '.',
          input_r_5: ''
        }, {
          cmsName: 'EShop',
          opt_1: 'url',
          input_1: '',
          opt_2: 'url',
          input_2: '',
          opt_3: 'url',
          input_3: '',
          opt_4: 'url',
          input_4: '',
          opt_5: 'url',
          input_5: '',
          opt_6: 'url',
          input_6: '',
          r_1: '.',
          input_r_1: 'eshopbutton',
          r_2: '.',
          input_r_2: 'product-price',
          r_3: '.',
          input_r_3: 'product-name',
          r_4: '.',
          input_r_4: '',
          r_5: '.',
          input_r_5: ''
        }, {
          cmsName: 'OpenCart',
          opt_1: 'url',
          input_1: 'checkout/cart',
          opt_2: 'url',
          input_2: 'checkout/cart',
          opt_3: 'url',
          input_3: 'checkout/cart',
          opt_4: 'url',
          input_4: 'checkout/cart',
          opt_5: 'url',
          input_5: 'checkout/cart',
          opt_6: 'url',
          input_6: 'checkout/cart',
          r_1: '.',
          input_r_1: 'cart',
          r_2: '.',
          input_r_2: 'product-price',
          r_3: '.',
          input_r_3: 'product-name',
          r_4: '.',
          input_r_4: '',
          r_5: '.',
          input_r_5: ''
        }, {
          cmsName: 'Virtuemart',
          opt_1: 'url',
          input_1: 'cart',
          opt_2: 'url',
          input_2: 'account',
          opt_3: 'url',
          input_3: 'edit_shipment',
          opt_4: 'url',
          input_4: 'cart',
          opt_5: 'url',
          input_5: 'editpayment',
          opt_6: 'url',
          input_6: '',
          r_1: '.',
          input_r_1: '',
          r_2: '.',
          input_r_2: 'product-price',
          r_3: '.',
          input_r_3: 'product-name',
          r_4: '.',
          input_r_4: '',
          r_5: '.',
          input_r_5: ''
        }, {
          cmsName: 'ZenCart',
          opt_1: 'url',
          input_1: '',
          opt_2: 'url',
          input_2: '',
          opt_3: 'url',
          input_3: '',
          opt_4: 'url',
          input_4: '',
          opt_5: 'url',
          input_5: '',
          opt_6: 'url',
          input_6: '',
          r_1: '.',
          input_r_1: '',
          r_2: '.',
          input_r_2: 'product-price',
          r_3: '.',
          input_r_3: 'product-name',
          r_4: '.',
          input_r_4: '',
          r_5: '.',
          input_r_5: ''
        }, {
          cmsName: 'Powerboutique',
          opt_1: 'url',
          input_1: 'panierb',
          opt_2: 'url',
          input_2: 'adresse_e_mail',
          opt_3: 'url',
          input_3: 'choix_livraison',
          opt_4: 'url',
          input_4: 'bon_de_commande',
          opt_5: 'url',
          input_5: 'bon_de_commande',
          opt_6: 'url',
          input_6: 'paiement',
          r_1: '.',
          input_r_1: 'bouton_selectionner_fiche_produit',
          r_2: '.',
          input_r_2: 'product-price',
          r_3: '.',
          input_r_3: 'product-name',
          r_4: '.',
          input_r_4: '',
          r_5: '.',
          input_r_5: ''
        }, {
          cmsName: 'Autre',
          opt_1: 'url',
          input_1: '',
          opt_2: 'url',
          input_2: '',
          opt_3: 'url',
          input_3: '',
          opt_4: 'url',
          input_4: '',
          opt_5: 'url',
          input_5: '',
          opt_6: 'url',
          input_6: '',
          r_1: '.',
          input_r_1: '',
          r_2: '.',
          input_r_2: '',
          r_3: '.',
          input_r_3: '',
          r_4: '.',
          input_r_4: '',
          r_5: '.',
          input_r_5: ''
        }
      ],
      // indique s'il faut afficher le loader
      loadingGet: false,
      loadingPost: false,
      dialogProgress: false
    }
  },

  mounted () {
    if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
      this.openDialogProgress()
    }
    if (this.$store.state._User.entLevel < 7) {
      this.alert = true
    }
  },
  created () {
    this.getOptions()
    /* eslint-disable */
    if (typeof (defautMotif) !== 'undefined') {
      defautMotif = 'settings_ecommerce'
    }
    else {
      setTimeout (function () {
        if (typeof (defautMotif) !== 'undefined') {
          defautMotif = 'settings_ecommerce'
        }
      }, 800);
    }
    /* eslint-enable */
  },
  methods: {
    getOptions () {
      this.loadingGet = true
      this.axios.get('get/settings_ecomm.php?desk=' + this.$store.state._Sites.siteSelected.LIC_DSK_ID)
      .then(response => {
        this.dataFromAjax = response.data
        this.init()
      })
      .catch()
      .then(_ => {
        this.loadingGet = false
      })
    },

    /**
     * Rempli les champs suivant les informations récupérées de la BDD
     * Formate les données du formulaire afin de les afficher correctement
     */
    init () {
      let cms = (this.dataFromAjax.DSK_ECOMM_CMS === '')
        ? 'Autre'
        : this.dataFromAjax.DSK_ECOMM_CMS
      this.dataFromAjax.cms = _.clone(_.find(this.cms, {'value': cms}))

      this.dataFromAjax.opt_1 = this.dataFromAjax.DSK_ECOMM_CART_ID.split('|')[0] ? _.find(this.opts, {'value': this.dataFromAjax.DSK_ECOMM_CART_ID.split('|')[0]}) : this.opts[0]
      this.dataFromAjax.input_1 = this.dataFromAjax.DSK_ECOMM_CART_ID.split('|')[1] || ''

      this.dataFromAjax.opt_2 = this.dataFromAjax.DSK_ECOMM_LOGIN_ID.split('|')[0] ? _.find(this.opts, {'value': this.dataFromAjax.DSK_ECOMM_LOGIN_ID.split('|')[0]}) : this.opts[0]
      this.dataFromAjax.input_2 = this.dataFromAjax.DSK_ECOMM_LOGIN_ID.split('|')[1] || ''

      this.dataFromAjax.opt_3 = this.dataFromAjax.DSK_ECOMM_DELIV_ID.split('|')[0] ? _.find(this.opts, {'value': this.dataFromAjax.DSK_ECOMM_DELIV_ID.split('|')[0]}) : this.opts[0]
      this.dataFromAjax.input_3 = this.dataFromAjax.DSK_ECOMM_DELIV_ID.split('|')[1] || ''

      this.dataFromAjax.opt_4 = this.dataFromAjax.DSK_ECOMM_SUMM_ID.split('|')[0] ? _.find(this.opts, {'value': this.dataFromAjax.DSK_ECOMM_SUMM_ID.split('|')[0]}) : this.opts[0]
      this.dataFromAjax.input_4 = this.dataFromAjax.DSK_ECOMM_SUMM_ID.split('|')[1] || ''

      this.dataFromAjax.opt_5 = this.dataFromAjax.DSK_ECOMM_PAIM_ID.split('|')[0] ? _.find(this.opts, {'value': this.dataFromAjax.DSK_ECOMM_PAIM_ID.split('|')[0]}) : this.opts[0]
      this.dataFromAjax.input_5 = this.dataFromAjax.DSK_ECOMM_PAIM_ID.split('|')[1] || ''

      this.dataFromAjax.opt_6 = this.dataFromAjax.DSK_ECOMM_VALID_ID.split('|')[0] ? _.find(this.opts, {'value': this.dataFromAjax.DSK_ECOMM_VALID_ID.split('|')[0]}) : this.opts[0]
      this.dataFromAjax.input_6 = this.dataFromAjax.DSK_ECOMM_VALID_ID.split('|')[1] || ''

      //  test du premier caractère afin de savoir s'il s'agit d'une class ou d'un id
      this.dataFromAjax.r_1 = this.dataFromAjax.DSK_ECOMM_BTN_AMOUNT[0] === '#' ? '#' : '.'
      this.dataFromAjax.input_r_1 = this.dataFromAjax.DSK_ECOMM_BTN_AMOUNT.substring(1)

      this.dataFromAjax.r_2 = this.dataFromAjax.DSK_ECOMM_BTN_ID[0] === '#' ? '#' : '.'
      this.dataFromAjax.input_r_2 = this.dataFromAjax.DSK_ECOMM_BTN_ID.substring(1)

      this.dataFromAjax.r_3 = this.dataFromAjax.DSK_ECOMM_BTN_NAME[0] === '#' ? '#' : '.'
      this.dataFromAjax.input_r_3 = this.dataFromAjax.DSK_ECOMM_BTN_NAME.substring(1)

      this.dataFromAjax.r_4 = this.dataFromAjax.DSK_ECOMM_CART_AMOUNT[0] === '#' ? '#' : '.'
      this.dataFromAjax.input_r_4 = this.dataFromAjax.DSK_ECOMM_CART_AMOUNT.substring(1)

      this.dataFromAjax.r_5 = this.dataFromAjax.DSK_ECOMM_CART_NB[0] === '#' ? '#' : '.'
      this.dataFromAjax.input_r_5 = this.dataFromAjax.DSK_ECOMM_CART_NB.substring(1)

      // Attention ici cloner le formulaire et non lui passer sa référence
      this.form = _.cloneDeep(this.dataFromAjax)
    },

    /**
     *  Valide le formulaire et update la BDD et le fichier XML pour le front
     */
    submit () {
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()

      dataToPost.append('DSK_ID', this.$store.state._Sites.siteSelected.LIC_DSK_ID)
      dataToPost.append('LIC_KEY', this.$store.state._Sites.siteSelected.LIC_KEY)
      dataToPost.append('DSK_ECOMM_CMS', this.form.cms.value)
      dataToPost.append('DSK_ECOMM_CART_ID', '')
      if (!_.isEmpty(this.form.opt_1) && !_.isEmpty(this.form.input_1)) {
        dataToPost.append('DSK_ECOMM_CART_ID', this.form.opt_1.value + '|' + this.form.input_1)
      }
      dataToPost.append('DSK_ECOMM_LOGIN_ID', '')
      if (!_.isEmpty(this.form.opt_2) && !_.isEmpty(this.form.input_2)) {
        dataToPost.append('DSK_ECOMM_LOGIN_ID', this.form.opt_2.value + '|' + this.form.input_2)
      }
      dataToPost.append('DSK_ECOMM_DELIV_ID', '')
      if (!_.isEmpty(this.form.opt_3) && !_.isEmpty(this.form.input_3)) {
        dataToPost.append('DSK_ECOMM_DELIV_ID', this.form.opt_3.value + '|' + this.form.input_3)
      }
      dataToPost.append('DSK_ECOMM_SUMM_ID', '')
      if (!_.isEmpty(this.form.opt_4) && !_.isEmpty(this.form.input_4)) {
        dataToPost.append('DSK_ECOMM_SUMM_ID', this.form.opt_4.value + '|' + this.form.input_4)
      }
      dataToPost.append('DSK_ECOMM_PAIM_ID', '')
      if (!_.isEmpty(this.form.opt_5) && !_.isEmpty(this.form.input_5)) {
        dataToPost.append('DSK_ECOMM_PAIM_ID', this.form.opt_5.value + '|' + this.form.input_5)
      }
      dataToPost.append('DSK_ECOMM_VALID_ID', '')
      if (!_.isEmpty(this.form.opt_6) && !_.isEmpty(this.form.input_6)) {
        dataToPost.append('DSK_ECOMM_VALID_ID', this.form.opt_6.value + '|' + this.form.input_6)
      }
      dataToPost.append('DSK_ECOMM_BTN_AMOUNT', '')
      if (!_.isEmpty(this.form.r_1) && !_.isEmpty(this.form.input_r_1)) {
        dataToPost.append('DSK_ECOMM_BTN_AMOUNT', this.form.r_1 + this.form.input_r_1)
      }
      dataToPost.append('DSK_ECOMM_BTN_ID', '')
      if (!_.isEmpty(this.form.r_2) && !_.isEmpty(this.form.input_r_2)) {
        dataToPost.append('DSK_ECOMM_BTN_ID', this.form.r_2 + this.form.input_r_2)
      }
      dataToPost.append('DSK_ECOMM_BTN_NAME', '')
      if (!_.isEmpty(this.form.r_3) && !_.isEmpty(this.form.input_r_3)) {
        dataToPost.append('DSK_ECOMM_BTN_NAME', this.form.r_3 + this.form.input_r_3)
      }
      dataToPost.append('DSK_ECOMM_CART_AMOUNT', '')
      if (!_.isEmpty(this.form.r_4) && !_.isEmpty(this.form.input_r_4)) {
        dataToPost.append('DSK_ECOMM_CART_AMOUNT', this.form.r_4 + this.form.input_r_4)
      }
      dataToPost.append('DSK_ECOMM_CART_NB', '')
      if (!_.isEmpty(this.form.r_5) && !_.isEmpty(this.form.input_r_5)) {
        dataToPost.append('DSK_ECOMM_CART_NB', this.form.r_5 + this.form.input_r_5)
      }

      // Si changement dans le formulaire alors on fait la requête afin de modifier les données en BDD
      if (!_.isEqual(this.form, this.dataFromAjax)) { // comparaison entre ce que l'on a reçu en AJAX et le form actuel
        // pour avoir accès à l'instance VueJS pendant la requête
        this.loadingPost = true
        this.axios.post('post/settings_ecomm.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then(response => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifSuccess'), context: 'success' })
          // les changements été pris en compte alors changement de valeur pour le form représentant les infos en BDD
          this.dataFromAjax = _.cloneDeep(this.form)
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure'), context: 'error' })
        })
        .then(_ => {
          this.loadingPost = false
        })
      } else {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('noChange'), context: 'warning' })
      }
    },

    /**
     *  Retrouve les valeurs récupérées en BDD par l'Ajax initial
     */
    reset () {
      this.form = _.cloneDeep(this.dataFromAjax)
    },

    /**
     *  Lors du changement de CMS on actualise les infos du formulaire en fonction du CMS
     */
    cmsChanged () {
      //  Lors du changement de CMS dans la liste on actualise le formulaire
      let cms = _.clone(_.find(this.cms, { 'value': this.form.cms.value }))
      this.form = _.cloneDeep(_.find(this.infosCMS, { 'cmsName': this.form.cms.value }))
      this.form.cms = cms
      this.form.opt_1 = _.clone(_.find(this.opts, { 'value': this.form.opt_1 }))
      this.form.opt_2 = _.clone(_.find(this.opts, { 'value': this.form.opt_2 }))
      this.form.opt_3 = _.clone(_.find(this.opts, { 'value': this.form.opt_3 }))
      this.form.opt_4 = _.clone(_.find(this.opts, { 'value': this.form.opt_4 }))
      this.form.opt_5 = _.clone(_.find(this.opts, { 'value': this.form.opt_5 }))
      this.form.opt_6 = _.clone(_.find(this.opts, { 'value': this.form.opt_6 }))
    },
    // ---------------------------
    // close dialog Progression install
    fermeDialogProgress () {
      this.dialogProgress = false
    },
    // ---------------------------
    // Ouvre la dialogueBox de progression de l'installation
    openDialogProgress () {
      this.dialogProgress = true
    }
  },

  watch: {
    '$store.state._Sites.siteSelected': function (v) {
      if (v) {
        this.getOptions()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/Ecomm.vue